import { z } from 'zod';

/**
 * One unified lifecycle for both agent-inferred continuity and user-asserted tracking: `pinned` is
 * simply an early state in the same enum as `assigned`/`completed`/`dismissed`, not a separate
 * system (Dima's framing, 2026-09-16 persistence meeting). `agent_tracked` is the default row state
 * before any user acts, and is also reserved for rows the pipeline may create on its own later.
 * `unassigned` is the distinct state for a row a person released: tracked, but with no owner.
 * `auto_resolved`/`superseded` are pipeline-written only — see `humanSettableTrackedItemStatuses`
 * in tracked-item-dto for what a caller may set directly.
 *
 * Its own module because both `finding-dto` (a finding's read-time `tracking` ref) and
 * `tracked-item-dto` (which imports `findingGroups` from `finding-dto`) need it.
 */
export const trackedItemStatuses = [
  'agent_tracked',
  'pinned',
  'assigned',
  'in_motion',
  'unassigned',
  'completed',
  'dismissed',
  'auto_resolved',
  'superseded',
] as const;
export type TrackedItemStatus = (typeof trackedItemStatuses)[number];
export const trackedItemStatusSchema = z.enum(trackedItemStatuses);
